export default "__VITE_ASSET__CFxUtc65__"